// The ARG's tiny bit of shared state. Level 1: Messenger drops a clue → `dir /a` in cmd.exe finds a hidden
// folder → basement.nfo names the door (basement.internetcoin.vip, inside Internet Explorer) and the riddle
// → the key opens the door → BASEMENT.exe appears on the desktop. All client-side; nothing is served.
export const BASEMENT_KEY = '88888'; // the eights that open the contract address (0x88888cC1…)
const KEY = 'ic:basement';
export const isUnlocked = () => {
  try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
};
export const unlock = () => {
  try { localStorage.setItem(KEY, '1'); localStorage.setItem('ic:basement:at', new Date().toISOString()); } catch (e) { /* private mode */ }
  window.dispatchEvent(new CustomEvent('ic:unlock', { detail: 'Basement' }));
};
export const unlockedAt = () => {
  try { return localStorage.getItem('ic:basement:at'); } catch (e) { return null; }
};
export const checkKey = k => String(k || '').trim().replace(/[^0-9a-z]/gi, '').toLowerCase() === BASEMENT_KEY;
